import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import DataTable from "../../../Components/Table/Table";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import AddButton from "../../../Components/AddButton/AddButton";
import Paginations from "../../../Components/Pagination/Pagination";
import hospitalImage from "./../../../Assets/Hospital/mykare-hospital.png";
import useInsurance from "./useInsurance";
import InsurancePopUp from "./InsurancePopUp";
import { checkPermission } from "../../../Utils/Permissions";
import { isEditable } from "@testing-library/user-event/dist/utils";

function Insurance({ isModal }) {
  const navigate = useNavigate();
  const navigateTo = () => {
    navigate("/HospitalAddPage");
  };
  const [tableHeader, setTableHeader] = useState([
    {
      id: 1,
      headText1: "Insurance Name",
      headText2: "Contact Person",
      headText3: "Contact Number",
      headText4: "Approval",
      headText5: "",
    },
  ]);
  const state = useInsurance();
  return (
    <Grid
      sx={{
        width: "100%",
        padding: "0px 25px",
      }}
    >
      <InsurancePopUp
        setOpenModal={state.setModal}
        openModal={state.modal.isOpen}
        data={state.modal}
      />
      <Grid
        sx={{
          width: "100%",
          height: "80%",
          backgroundColor: "#f9fbfc",
          borderRadius: "15px",
          padding: "20px",
        }}
      >
        <Grid lg={12} container justifyContent="flex-end" alignItems={"center"}>
          <Grid item lg={1.7}>
            {checkPermission("KARE_DB_INSURANCE_EDIT") && (
              <AddButton
                style={{ position: "absolute", top: "34px", paddingX: "10px" }}
                labelName={"Add New Insurance"}
                onClick={() => state.handleOpenPopup(state.addNew)}
                viewHeight={"40px"}
                borderRadius={"50px"}
                width="fit-content"
              />
            )}
          </Grid>
        </Grid>
        <DataTable
          isCity={true}
          isModal={isModal}
          tableHeader={tableHeader}
          data={state?.insurances.insurances}
          handleEdit={state.handleOpenEditPopUp}
          onClick={(value) => {
            checkPermission("KARE_DB_INSURANCE_EDIT") &&
              state.handleOpenEditPopUp(value);
          }}
          handleCheckboxChange={state.handleApprovePopup}
          handleDelete={state.handleDelete}
          isEdit={checkPermission("KARE_DB_INSURANCE_EDIT")}
          isDelete={checkPermission("DB_INSURANCE_DELETE")}
          isApproval={checkPermission("DB_INSURANCE_APPROVAL")}
        />
        <Grid
          sx={{ height: "88px", width: "100%" }}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Paginations
            page={state.page}
            count={
              state?.insurances?.count <= 10
                ? 1
                : Math.ceil(state?.insurances?.count / 10)
            }
            paginationData={state.setPage}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Insurance;
